import { gql } from "@apollo/client";

export const UPDATE_PROVEEDOR_DISTRIBUIDOR = gql`
    mutation updateProveedorDistribuidor(
        $idProveedorDistribuidor: Int!,
        $codigoSAP: String!,
        $razonSocial: String!,
        $contacto: String!,
        $telefonoAdicional: String!,
        $observacion: String!,
        $activo: Boolean!,
        $email: String!,
        $idDeposito: Int!,
        $metodoCobroBulto: [EditProveedorMetodoCobroBultoInput],
        $metodoCobroKilo: [EditProveedorMetodoCobroKiloInput],
        $metodoCobroKM: [EditProveedorMetodoCobroKMInput]
         ){
        updateProveedorDistribuidor(
            input: {
                idProveedorDistribuidor: $idProveedorDistribuidor,
                codigoSAP: $codigoSAP,
                razonSocial: $razonSocial,
                contacto: $contacto,
                telefonoAdicional: $telefonoAdicional,
                observacion: $observacion,
                activo: $activo,
                email: $email,
                idDeposito: $idDeposito,
                metodoCobroBulto: $metodoCobroBulto,
                metodoCobroKilo: $metodoCobroKilo,
                metodoCobroKM: $metodoCobroKM
            }
        ) {
            idProveedorDistribuidor
        }
    }
`;